module.exports = __webpack_public_path__ + "img/badge-legal-danger.39a237b2.svg";